export const environment = {
  production: false,
  apiURL: 'https://demo.shohay.net',
  envName: 'stage',
  shohayBlogToken: 'shohaystagetoken',
  firebaseConfig: {
    apiKey: 'AIzaSyBX9iJHQJJmSrhEFInEa1bA8g7zn84Roas',
    authDomain: 'shohay-notification.firebaseapp.com',
    projectId: 'shohay-notification',
    storageBucket: 'shohay-notification.firebasestorage.app',
    messagingSenderId: '431828719944',
    appId: '1:431828719944:web:ddafa772195cad782fbb7d',
    measurementId: 'G-5WZH4XHGRK',
    vapidKey:
      'BBqHAYFveJ23aVE0GJcxaupqW4oh_nE7iOoRn9XX9YQG3l9rmQoKlaNPCIsZ3Jmly5ebd2SbtXHp9_w251XZAfw',
  },
};
